import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref} from "vue";
import {useRouter} from "vue-router";
import {user} from "@/api";
import {useApi} from "@/api/handler";
import store from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordLogin',
  setup(__props) {

const routers = useRouter();

const passwordVisible = ref<boolean>(false);
const email = ref<string>("");
const password = ref<string>("");

function handleLogin() {
  useUserLogin()
}

function handleForgetPassword() {
  store.dispatch('snackBarModule/showError', '功能暂未开放')
}

const useUserLogin = () => {
  useApi({
    api: user.PasswordLogin(email.value, password.value),
    onSuccess: callback => {
      window.localStorage.setItem("user", JSON.stringify(callback.data));
      setTimeout(() => {routers.push("/")}, 1000)
    },
    tip: '登录成功'
  })
}


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_text_field, {
      density: "compact",
      placeholder: "请输入邮箱",
      "prepend-inner-icon": "mdi-email-outline",
      variant: "outlined",
      prefix: "   ",
      class: "mb-2",
      rounded: "",
      modelValue: email.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_v_text_field, {
      "append-inner-icon": passwordVisible.value ? 'mdi-eye-off' : 'mdi-eye',
      density: "compact",
      placeholder: "请输入密码",
      prefix: "   ",
      variant: "outlined",
      rounded: "",
      modelValue: password.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
      "prepend-inner-icon": "mdi-lock-outline",
      type: passwordVisible.value ? 'text' : 'password',
      "onClick:appendInner": _cache[2] || (_cache[2] = ($event: any) => (passwordVisible.value = !passwordVisible.value))
    }, null, 8, ["append-inner-icon", "modelValue", "type"]),
    _createElementVNode("div", { class: "d-flex justify-end" }, [
      _createElementVNode("a", {
        class: "text-caption text-decoration-none text-blue",
        href: "#",
        rel: "noopener noreferrer",
        onClick: handleForgetPassword
      }, " 忘记密码?")
    ]),
    _createVNode(_component_v_btn, {
      block: "",
      rounded: "",
      color: "blue-lighten-1",
      class: "mt-4",
      size: "large",
      onClick: handleLogin
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [
        _createTextVNode("登录")
      ])),
      _: 1,
      __: [3]
    })
  ], 64))
}
}

})